// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hZEas","header":"styles_header__1Gvth","simulator":"styles_simulator__AIlJ8","editableTitle":"styles_editableTitle__alC4O"};